import api from './api';

/**
 * NIST SP 800-53 Rev 5 Service
 * RAG-based semantic search for NIST Security and Privacy Controls
 */
const nistService = {
    /**
     * Chat with NIST SP 800-53 Rev 5 using RAG + LLM hybrid
     * @param {string} query - The user's question
     * @param {string|null} model - AI model identifier (e.g., 'groq:llama-4-scout-17b')
     * @param {Array|null} conversationHistory - Previous messages [{role, content}]
     * @returns {Promise<Object>} Response with answer, controls, and mode
     */
    chat: async (query, model = null, conversationHistory = null) => {
        try {
            const payload = { query };
            if (model) payload.model = model;
            if (conversationHistory && conversationHistory.length > 0) {
                payload.conversation_history = conversationHistory;
            }
            const response = await api.post('/nist/chat', payload);
            return response.data;
        } catch (error) {
            console.error('Error in NIST chat:', error);
            throw error;
        }
    },

    /**
     * Download Market Validation Report as PDF
     * @returns {Promise<Blob>} PDF file blob
     */
    downloadMarketValidationReport: async () => {
        try {
            const response = await api.get('/nist/market-validation-report/download', {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Error downloading Market Validation Report:', error);
            throw error;
        }
    }
};

export default nistService;
